import React from 'react';
import PropTypes from 'prop-types';
import { Modal, ModalBody, ModalFooter, Table } from 'reactstrap';
import Translate from '../common/Translate';

const HistorySale = ({ isOpen, handleClose }) => (
  <Modal isOpen={isOpen} toggle={() => handleClose(!isOpen)} centered className="modal-xl">
    <ModalBody className="remove-padding">
      <div className="p-3">
        <div className="">
          <h3>
            <Translate code="atHistoryTitle" />
          </h3>
        </div>
      </div>
      <Table striped className="table-fixed">
        <thead>
          <tr>
            <th>
              <Translate code="history_sale_datetime" />
            </th>
            <th>
              <Translate code="history_sale_user" />
            </th>
            <th>
              <Translate code="history_sale_changes" />
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>@Test</td>
            <td>@Test</td>
            <td>@Test</td>
          </tr>
          <tr>
            <td>@Test</td>
            <td>@Test</td>
            <td>@Test</td>
          </tr>
          <tr>
            <td>@Test</td>
            <td>@Test</td>
            <td className="text-break">
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Exercitationem eos ut officia est nesciunt
              mollitia beatae dicta sunt cupiditate delectus atque impedit molestias aliquam tenetur officiis cum, nam
              ab consequatur.
            </td>
          </tr>
        </tbody>
      </Table>
    </ModalBody>
    <ModalFooter className="justify-content-center">
      <button className="btn btn-1" type="button" onClick={() => handleClose(!isOpen)}>
        <Translate code="close" />
      </button>
    </ModalFooter>
  </Modal>
);

export default HistorySale;

HistorySale.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
};
